module.exports = __webpack_public_path__ + "img/add.2c12b011.svg";